import React, { useEffect, useState } from 'react';
import { IonContent, IonCard, IonGrid, IonRow, IonCol } from '@ionic/react';
import './HomeSections.css';
import encuestas from '../../asset/img/home/encuestas.png';
import sos from '../../asset/img/home/sos.png';
import paraSeguridad from '../../asset/img/home/seguridad.png';
import pqrs from '../../asset/img/home/pqrs.png';
import mastin from '../../asset/img/home/mastin.png';
// import { InAppBrowser, InAppBrowserOptions } from '@awesome-cordova-plugins/in-app-browser';
import ReactGA from "react-ga4";
import { Device } from '@capacitor/device';

ReactGA.send({ hitType: "pageview", page: "/pages/Home", title: "Home" });

const PHP_PROXY_URL_HOME_SECTIONS = 'https://portal.mastinseguridad.com/apisapp/ga_proxy.php';

const getOrCreateGaClientIdForHome = (): string => {
  let clientId = localStorage.getItem('ga_client_id');
  if (!clientId) {
    clientId = typeof self !== 'undefined' && self.crypto?.randomUUID ? 
               self.crypto.randomUUID() : 
               `uuid-${Date.now()}-${Math.random().toString(36).substring(2)}`;
    localStorage.setItem('ga_client_id', clientId);
  }
  return clientId;
};

const user = localStorage.getItem('profile') as string;
const profile = user ? JSON.parse(user) : null;
const userIdForGa = profile?.id?.toString() ?? undefined; 

const clientIdForGa = getOrCreateGaClientIdForHome();

// const payloadToProxyHome = {
//   client_id: clientIdForGa,
//   user_id: userIdForGa, 
//   event_name: 'page_view', 
//   event_params: {         
//     page_location: '/pages/Home',
//     page_title: 'Home'
//   }
// };

// console.log('HomeSections: Enviando page_view inicial a proxy GA:', payloadToProxyHome);
// fetch(PHP_PROXY_URL_HOME_SECTIONS, {
//   method: 'POST',
//   headers: { 'Content-Type': 'application/json' },
//   body: JSON.stringify(payloadToProxyHome)
// })
// .then(response => {
//   if (!response.ok) {
//     response.json().then(err => console.error('Error desde proxy GA (Home page_view):', err)).catch(() => console.error('Error desde proxy GA (Home page_view), respuesta no JSON'));
//   } else {
//     response.json().then(data => console.log('Éxito vía proxy GA (Home page_view):', data)).catch(() => console.log('Éxito vía proxy GA (Home page_view), respuesta no JSON'));
//   }
// })
// .catch(error => {
//   console.error('Error de red contactando proxy GA (Home page_view):', error);
// });

const HomeSections: React.FC = () => {
  // const data = localStorage.getItem('profile') as string;
  // const urlSeguridad = 'https://mastinseguridad.com/blog/?&utm_source=app_movil&utm_medium=boton&utm_campaign=paratuseguridad';

  //#Sistema operativo
  const [os, setOs] = useState('');

  useEffect(() => {
    const getDeviceInfo = async () => {
      const info = await Device.getInfo();
      setOs(info.operatingSystem); // Obtiene el sistema operativo
    };

    getDeviceInfo();
  }, []);

  console.log(os);

  //#ScrollPercent
  let scrollPercent = 0;
  let text = '';
  let className = '';

  window.addEventListener('scroll', () => {
    const scrollTop = window.scrollY;
    const scrollHeight = document.body.scrollHeight - window.innerHeight;
    scrollPercent = (scrollTop / scrollHeight) * 100;

    console.log(scrollPercent); //Imprimir el porcentaje de scroll
  });

  //  #clase y texto de los Botones

  document.querySelectorAll('.clickable').forEach(item => {
    item.addEventListener('click', event => {
      const target = event.target as HTMLElement;
      text = target.innerText;
      className = target.className;

      console.log(text); // Imprimir el texto al hacer clic
      console.log(className); // Imprimir la clase al hacer clic
    });
  });

  const user = localStorage.getItem('profile') as string;
  const profile = JSON.parse(user);
  console.log(profile.id); 

  const sendClickEventToProxy = (clickTextValue: string) => {
    const clientId = getOrCreateGaClientIdForHome(); 
    
    const userFromStorage = localStorage.getItem('profile') as string;
    const profileFromStorage = userFromStorage ? JSON.parse(userFromStorage) : null;
    const userIdValue = profileFromStorage?.id?.toString() ?? undefined;
    
    const payloadForClick = {
      client_id: clientId,
      user_id: userIdValue, 
      event_name: 'click',
      event_params: {
        page_location: '/pages/Home', 
        page_title: 'Home',
        os: os, 
        percent_scrolled: scrollPercent, 
        click_text: clickTextValue
      }
    };

    console.log('Enviando evento click a proxy GA:', payloadForClick);
    fetch(PHP_PROXY_URL_HOME_SECTIONS, { // Reutilizamos la URL del proxy
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payloadForClick)
    })
    .then(response => { // Mismo manejo de respuesta que para el page_view
      if (!response.ok) {
        response.json().then(err => console.error(`Error proxy GA (click - ${clickTextValue}):`, err)).catch(() => console.error(`Error proxy GA (click - ${clickTextValue}), resp no JSON`));
      } else {
        response.json().then(data => console.log(`Éxito proxy GA (click - ${clickTextValue}):`, data)).catch(() => console.log(`Éxito proxy GA (click - ${clickTextValue}), resp no JSON`));
      }
    })
    .catch(error => {
      console.error(`Error red proxy GA (click - ${clickTextValue}):`, error);
    });
  };

  return (
    <IonContent className='card-content'>
      <IonGrid className='card-icons' >
        <IonRow>
          <IonCol className='card-base'>
            <IonCard className="card-home">
              <div className="content">
                <button
                  className="btn-home"
                  onClick={() => {
                    window.location.href = "/pqrs";
                    ReactGA.event({
                      action: "click", // Event name
                      category: "PQRS", // optional
                      label: os,
                      value: 1, // optional, must be a number
                      nonInteraction: false, // optional, true/false
                      transport: "xhr", // optional, beacon/xhr/image
                      //userId: profile.id
                    });
                    sendClickEventToProxy('PQRS');
                  }}
                >PQRS</button>
                <img className='card-home-img' src={pqrs} alt='' />
              </div>
            </IonCard>
          </IonCol>
          <IonCol className='card-base'>
            <IonCard className="card-home">
              <div className="content">
                <button
                  className="btn-home"
                  onClick={() => {
                    window.location.href = '/encuestas';
                    ReactGA.event({
                      action: "click", // Event name
                      category: "Encuestas", // optional
                      label: os,
                      value: 4, // ¿podemos saber el porcentaje de scroll que realizó el usuario?
                      nonInteraction: false, // optional, true/false
                      transport: "xhr", // optional, beacon/xhr/image
                    });
                     sendClickEventToProxy('Encuestas');
                  }}
                >
                  Encuestas
                </button>
                <img className='card-home-img' src={encuestas} alt="Encuestas" />
              </div>
            </IonCard>
          </IonCol>
          
        </IonRow>

        <IonRow>
          <IonCol className='card-base'>
            <IonCard className="card-home">
              <div className="content">
                <button
                  className="btn-home"
                  onClick={() => {
                    window.location.href = '/noticias';
                    ReactGA.event({
                      action: "click", // Event name
                      category: "Noticias", // optional
                      label: os,
                      value: 3, // ¿podemos saber el porcentaje de scroll que realizó el usuario?
                      nonInteraction: false, // optional, true/false
                      transport: "xhr", // optional, beacon/xhr/image
                    });
                    sendClickEventToProxy('Seguridad');
                  }}
                >
                  Para su <br /> seguridad
                </button>
                <img className='card-home-img' src={paraSeguridad} alt="Para su seguridad" />
              </div>
            </IonCard>
          </IonCol>

          <IonCol className='card-base'>
            <IonCard className="card-home">
              <div className="content">
                <button
                  className="btn-home btn-mastin"
                  onClick={() => {
                    window.location.href = 'https://mastinseguridad.com/';
                    ReactGA.event({
                      action: "click", // Event name
                      category: "Conozca Mastin", // optional
                      label: os,
                      value: 5, // ¿podemos saber el porcentaje de scroll que realizó el usuario?
                      nonInteraction: false, // optional, true/false
                      transport: "xhr", // optional, beacon/xhr/image
                    });
                    sendClickEventToProxy('Conozca Mastin');
                  }}
                >Conozca Mastin</button>
                <img className='card-home-img' src={mastin} alt='' />
              </div>
            </IonCard>
          </IonCol>
        </IonRow>

        <IonRow className='card-5'>
          <IonCol className='card-base'>
            <IonCard className="card-home">
              <div className="content">
                <button
                  className="btn-home"
                  onClick={() => {
                    window.location.href = "/boton-sos";
                    ReactGA.event({
                      action: "click", // Event name
                      category: "SOS", // optional
                      label: os,
                      value: 2, // optional, must be a number
                      nonInteraction: false, // optional, true/false
                      transport: "xhr", // optional, beacon/xhr/image
                    });
                    sendClickEventToProxy('SOS');
                  }}
                >SOS</button>
                <img className='card-home-img' src={sos} alt='' />
              </div>
            </IonCard>
          </IonCol>
        </IonRow>
      </IonGrid>
    </IonContent>
  );
};

export default HomeSections;